<div [formGroup]="form">
    <mat-form-field class="phoneNumberleft" hideRequiredMarker>
        <mat-label>{{label}}</mat-label>

        <input matInput class="phone_number" type="text" [maxlength]="selectedCountry?.length" [minlength]="selectedCountry?.length" appOnlynumber [formControlName]="control" (invalid)="$event.preventDefault()" (input)="form.get(control)!.markAsDirty()" (ngModelChange)="updatePhoneValidators()">
        
        <span matPrefix class="mr-3" *ngIf="icon"><img [src]="icon"></span>

        <mat-select matSuffix (selectionChange)="selectChangeed($event)" disableRipple panelClass="country-code-panel"
            style="width: 80px;" [formControlName]="codeControl" [class.loading]="loading">
            <mat-select-trigger>
                <img [src]="selectedCountry?.image" width="20" height="15"
                    style="vertical-align: middle; margin-right: 4px;" alt="flag" />
                {{ selectedCountry?.code }}
            </mat-select-trigger>
            <ng-container *ngIf="countryCodes.length">
                <mat-option [value]="country.code" *ngFor="let country of countryCodes">
                    <img [src]="country.image" width="20" height="15" class="flag"
                        style="vertical-align: middle; margin-right: 4px;" />
                    {{country.code}}
                </mat-option>
            </ng-container>
        </mat-select>
        <mat-hint class="pt-1" *ngIf="!isRequired">{{"general.optional"|translate}}</mat-hint>
        <mat-error *ngIf="hasError(control, 'required')">
            {{ "form_message.Required" | translate }}
        </mat-error>
         <!-- <mat-error *ngIf="hasError(control, 'maxlength')">
            {{ "forms.maxLength_number" | translate :{num:selectedCountry?.length} }}
        </mat-error> -->
        <mat-error *ngIf="hasError(control, 'startsWith') || hasError(control, 'minlength') || hasError(control, 'maxlength')">
            {{ 'general.phone number validation' | translate : { length: selectedCountry?.length, startWith: selectedCountry?.startsWith} }}
        </mat-error>
        <!-- <mat-error *ngIf="hasError(control, 'minlength')">
            {{ "forms.Phone Number Length should be" | translate : { num: selectedCountry?.length } }}
        </mat-error>
        <mat-error *ngIf="hasError(control, 'startsWith')">
            {{ 'general.phone number must start with' | translate : { num: selectedCountry?.startsWith} }}
        </mat-error> -->
    </mat-form-field>
</div>